import { useState, useEffect } from 'react';
import { apiClient } from '../../lib/api';
import { WorkflowSchema, ParameterTemplate, DEFAULT_PARAMETER_TEMPLATES } from '../../components/workflows/nodes/config/parameterTemplates';

interface UseWorkflowSchemaReturn {
  parameterTemplates: Record<string, ParameterTemplate>;
  workflowSchema: WorkflowSchema | null;
  loading: boolean;
  error: string | null;
}

export const useWorkflowSchema = (): UseWorkflowSchemaReturn => {
  const [workflowSchema, setWorkflowSchema] = useState<WorkflowSchema | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchSchema = async () => {
      try {
        setLoading(true);
        setError(null);
        
        const schema = await apiClient.getWorkflowSchema();
        setWorkflowSchema(schema);
      } catch (err) {
        console.error('Failed to fetch workflow schema:', err);
        setError(err instanceof Error ? err.message : 'Failed to fetch workflow schema');
      } finally {
        setLoading(false);
      }
    };

    fetchSchema();
  }, []);

  // Convert schema to parameter templates format
  const parameterTemplates: Record<string, ParameterTemplate> = {};
  
  if (workflowSchema) {
    Object.entries(workflowSchema.activity_definitions).forEach(([activityType, definition]) => {
      parameterTemplates[activityType] = definition.parameter_schema;
    });
  }

  // Fall back to default templates if schema is not loaded
  const finalTemplates = Object.keys(parameterTemplates).length > 0 
    ? parameterTemplates 
    : DEFAULT_PARAMETER_TEMPLATES;

  return {
    parameterTemplates: finalTemplates,
    workflowSchema,
    loading,
    error
  };
};